import type { PezPayloadApi, PezTransformApi, PhotosPezResponse } from '@/api/types/photo-effects'

function isPezPayload(value: unknown): value is PezPayloadApi {
  if (!value || typeof value !== 'object') return false

  const record = value as Record<string, unknown>

  if ('payload' in record && record.payload != null) return false

  return (
    typeof record.pezId === 'string' ||
    typeof record.pezUrl === 'string' ||
    Array.isArray(record.pezTransforms)
  )
}

/** Unwrap Larry/Core3 pez responses (flat or nested `payload.result`). */
export function normalizePhotoPezPayload(raw: unknown): {
  pezId: string
  pezUrl: string
  pezTransforms: PezTransformApi[]
} {
  let payload: PezPayloadApi | null = null

  if (isPezPayload(raw)) {
    payload = raw
  } else if (raw && typeof raw === 'object' && 'payload' in raw) {
    const envelope = raw as PhotosPezResponse
    const inner = envelope.payload

    if (Array.isArray(inner)) {
      payload = inner[0] ?? null
    } else if (isPezPayload(inner)) {
      payload = inner
    }
  }

  if (!payload) {
    throw new Error('Invalid pez response')
  }

  if (payload.result === false) {
    throw new Error('Pez request failed')
  }

  const pezId = typeof payload.pezId === 'string' ? payload.pezId : ''
  const pezUrl = typeof payload.pezUrl === 'string' ? payload.pezUrl : ''

  if (!pezId || !pezUrl) {
    throw new Error('Pez response missing pezId or pezUrl')
  }

  const pezTransforms = Array.isArray(payload.pezTransforms) ? payload.pezTransforms : []

  return { pezId, pezUrl, pezTransforms }
}
